<template>
  <div class="page-ilava">
    <div class="container pt-4 pb-5">
      
      <div class="pt-5">
        <h1>
          {{lg('',{
            en: 'iLAVA DAO Membership',
            zh: 'iLAVA DAO 会员系统',
          })}}
        </h1>
      </div>

      <!-- 左右结构 -->
      <div class="row">
        <div class="col-md-6">
          <div class="pt-5">
            <h2>
              {{lg('',{
                en: 'Your Real-Time APY',
                zh: '您的实时APY',
              })}}
            </h2>
            <div 
              class="c b i pt-4" 
              style="font-size: 58px;margin-left: -8px;font-family: vertana;"
              >
              {{res_num_apy | bfh}}
            </div>
            <div class="mt-5">
              <div 
                class="sp-num-member"
                v-html="calcHtmlForNumMember(res_num_membership)"
                >
              </div>
              <div class="mt-3">
                {{lg('',{
                  en: 'People have already become iLAVA members',
                  zh: '人已成为iLAVA会员',
                })}}
              </div>

              <!-- btns -->
              <div class="mt-4">

                <button 
                  @click="toggleRiskTip(); on_modal_tab = 'mint'"
                  class="btn btn-primary btn-lg rounded pl-4 pr-5">
                  <i class="fas fa-arrow-alt-circle-right mr-3"></i>
                  {{lg('',{
                    en: 'Mint iLAVA',
                    zh: '铸造 iLAVA',
                  })}}
                </button>

                <button 
                  @click="toggleRiskTip(); on_modal_tab = 'redeem'"
                  class="btn btn-lg rounded pl-4 pr-5 ml-4">
                  <span class="c">
                    <i class="far fa-arrow-alt-circle-left mr-3"></i>
                    {{lg('',{
                      en: 'Redeem',
                      zh: '赎回',
                    })}}
                  </span>
                </button>
                
              </div>

            </div>
          </div>
        </div>
        <div class="col-md-6 pt-5">
          
          <!-- 右侧还分左右 -->
          <div class="row pt-4">
            <div class="col-5">

              <!-- card 1 -->
              <div class="bg-sp radius-sp pl-4 py-4">
                <div class="mb-3">
                  <span class="icon-sp">
                    <img src="/static/img/page_ilava_icon_01.png">
                  </span>
                </div>
                <h4 class="c">
                  {{ res_num_ilava_balance | tofixed4 | qfw}}
                </h4>
                <div>
                  {{lg('',{
                    en: 'My iLAVA',
                    zh: '我的 iLAVA',
                  })}}
                </div>
              </div>
            </div>
            <div class="col-7">

              <!-- card 2 -->
              <div class="bg-sp radius-sp pl-4 py-4">
                <div class="mb-3">
                  <span class="icon-sp">
                    <img src="/static/img/page_ilava_icon_02.png">
                  </span>
                </div>
                <h4 class="c">
                  {{ res_num_ilava_reward | tofixed13 | qfw}}
                </h4>
                <div>
                  {{lg('',{
                    en: 'Membership Rewards',
                    zh: '会员奖励',
                  })}}
                  iLAVA
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- 统计 -->
      <div class="mt-5 border-top pt-5">
        <div>
          {{lg('',{
            en: 'iLAVA Stats',
            zh: 'iLAVA 统计',
          })}}
        </div>
        <div class="d-flex">
          <span>
            {{lg('',{
              en: 'Number of LAVA Staked',
              zh: '总质押LAVA',
            })}}
          </span>
          <span class="ml-auto">
            {{res_num_ilava_total_supply*100?res_num_ilava_total_supply*100:'-' | tofixed2 | qfw }}
          </span>
        </div>
        <div class="d-flex">
          <span>
            {{lg('',{
              en: 'iLAVA Minted',
              zh: '总铸造iLAVA',
            })}}
          </span>
          <span class="ml-auto">
            {{res_num_ilava_total_supply | tofixed2 | qfw }}
          </span>
        </div>
        <div class="d-flex">
          <span>
            {{lg('',{
              en: 'Current Exit Fee Rate',
              zh: '退会费率',
            })}}
          </span>
          <span class="ml-auto">
            0%
          </span>
        </div>
        <div class="d-flex">
          <span>
            {{lg('',{
              en: 'Exit membership fee income(iLAVA)',
              zh: '退会费收入',
            })}}
          </span>
          <span class="ml-auto c">
            {{res_num_ilava_income | tofixed2 | qfw }}
          </span>
        </div>
      </div>

      <UiModal
        :open="status_show_modal"
        class="modal-ilava-sp"
        @close="toggleModal()"
        >
        <div class="px-4 pb-4 pt-3">
          <div class="ui-tabset-style2 border-bottom b" style="font-size: 16px;">
            <span 
              @click="on_modal_tab = 'mint'"
              :class="['tab',{'on': on_modal_tab === 'mint'}]"
              >
              {{lg('',{
                en: 'Mint',
                zh: '铸造',
              })}}
            </span>
            <span 
              @click="on_modal_tab = 'redeem'"
              :class="['tab',{'on': on_modal_tab === 'redeem'}]"
              >
              {{lg('',{
                en: 'Redeem',
                zh: '赎回',
              })}}
            </span>
          </div>

          <formMint
            v-if="on_modal_tab === 'mint'"
          />
          <formRedeem
            v-if="on_modal_tab === 'redeem'"
          />

        </div>
      </UiModal>

      <UiModal
        :open="status_show_risk_tip"
        class="modal-risk-tip-sp"
        @close="status_show_risk_tip = false"
      >
        <div class="pt-4 pb-5 px-4">

          <h5 class="py-1 text-muted text-center">
            {{lg('',{
              en: 'Risk Disclaimer',
              zh: '风险提示',
            })}}
          </h5>
          <!-- tips -->
          <div 
            class="border p-3 small" 
            style="max-height: 200px; overflow: auto; line-height: 22px;background: rgba(0,0,0,0.3);border-radius: 5px;"
            >
            <div class="mb-1">
              {{lg('',{
                en: '1.You have to pay an exit fee when you redeem iLAVA tokens back to LAVA. This exit fee will be distributed to all remaining iLAVA holders.',
                zh: '1. 当您将iLAVA代币赎回成LAVA时，您需要缴纳一笔退会费。这笔退会费，会以 iLAVA 的形式，即时分配给未退出的所有iLAVA 持有者。',
              })}}
            </div>

            <!-- <div class="mb-1">
              {{lg('',{
                en: '2. You will be entering the wallet address of your referrer, who will receive rewards for inviting you to mint iLAVA. Please ensure that the address entered is correct, because you will not be able to change it.',
                zh: '2. 当您输入推荐人的钱包地址后，推荐人将因邀请您铸造iLAVA而获得奖励。地址输入后无法更改，请确保输入的地址是正确的。',
              })}}
            </div>

            <div class="mb-1">
              {{lg('',{
                en: '3. Your referrer must already hold iLAVA to be eligible.',
                zh: '3. 您的推荐人必须已经持有iLAVA才拥有推荐资格。',
              })}}
            </div> -->
          </div>
          <div class="mt-3">
            <label class="small usn" style="line-height: 22px;">
              <input 
                v-model="status_checked_risk_tip"
                type="checkbox" 
                class="mr-2"
              >
              {{lg('',{
                en: 'I have read, understand, and agree to the Terms of Service.',
                zh: '我确认我已阅读、理解并同意用户使用协议。',
              })}}
            </label>

            <button 
              :disabled="!status_checked_risk_tip" 
              class="btn btn-primary w-100 btn-lg mt-4"
              @click="toggleModal(true)"
              >
              {{lg('',{
                en: 'Continue',
                zh: '继续',
              })}}
            </button>
          </div>
        </div>
      </UiModal>

    </div>
  </div>
</template>

<script>

import {mapActions} from 'vuex'

import formMint from './form_mint.vue'
import formRedeem from './form_redeem.vue'

export default {
  name: 'ilava',
  components: {
    formMint,
    formRedeem,
  },
  props: [],
  data() {
    return {
      status_show_risk_tip: false,
      status_checked_risk_tip: false,


      status_show_modal: false,
      on_modal_tab: 'mint',

      res_num_apy: '-',
      res_num_membership: '----',

      res_num_ilava_balance: '-',
      res_num_ilava_reward: '-',

      res_num_ilava_total_supply: '-',
      res_num_ilava_income: '-',
    }
  },
  computed: {},
  watch: {
    'v.$store.state.web3.account'(val){
      if(val){
        this.run()
      }
    }
  },
  methods: {

    ...mapActions([
      'iLAVA_getAPY',
      'iLAVA_getMembers',
      'iLAVA_getiLavaBalance',
      'iLAVA_getILAVAReward',
      'iLAVA_getiLavaTotalSupply',
      'iLAVA_getReemTotal',
    ]),

    // 加样式
    calcHtmlForNumMember(num){
      let temp = (num + '').trim()
      let arr = temp.split('')
      let html = ''
      arr.forEach(char => {
        html += `<span class="bg-sp c-border-sp">${char}</span>`
      })
      return html
    },

    // 风险提示
    toggleRiskTip(val){
      if( (val || !this.status_show_modal) && this.status_checked_risk_tip){
        this.toggleModal(true)
        return
      }
      this.status_show_risk_tip = (val !== undefined ? val : !this.status_show_risk_tip)
    },

    // 主操作form
    toggleModal(val){
      this.status_show_risk_tip = false
      this.status_show_modal = (val !== undefined ? val : !this.status_show_modal)
    },
    async run(){
      let v = this
      
      let address_my  = v.$store.state.web3.account

      let res_num_apy_fn = v.iLAVA_getAPY()
      let res_num_membership_fn = v.iLAVA_getMembers()
      let res_num_ilava_balance_fn,res_num_ilava_reward_fn
      if(address_my){
        res_num_ilava_balance_fn = v.iLAVA_getiLavaBalance({address: address_my})
        res_num_ilava_reward_fn = v.iLAVA_getILAVAReward({address: address_my})
      }
      let res_num_ilava_total_supply_fn = v.iLAVA_getiLavaTotalSupply()
      let res_num_ilava_income_fn = v.iLAVA_getReemTotal()
      
      v.res_num_apy = await res_num_apy_fn
      v.res_num_membership = ((await res_num_membership_fn) + '').padStart(4,'0')

      
      if(address_my){
        v.res_num_ilava_balance = await res_num_ilava_balance_fn
        v.res_num_ilava_reward = await res_num_ilava_reward_fn
      }

      v.res_num_ilava_total_supply = await res_num_ilava_total_supply_fn
      v.res_num_ilava_income = await res_num_ilava_income_fn
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss">
  .page-ilava{

    .bg-sp{
      background-color: #222;
      color: #eee;
    }
    .bg-sp2{
      background-color: #303030;
      color: #eee;
    }
    .c-border-sp{
      border: 1px solid #444;
    }
    .radius-sp{
      border-radius: 40px;
    }
    .sp-num-member{
      span{
        display: inline-block;
        margin-right: 30px;
        width: 45px;
        height: 55px;
        line-height: 55px;
        font-size: 27px;
        font-weight: bold;
        border-radius: 8px;


        text-align: center;
      }
    }

    .icon-sp{
      display: inline-block;
      width: 40px;
      height: 40px;
      text-align: center;
      img{
        max-height: 100%;
      }
    }

    .modal-ilava-sp{
      .shell{
        background-color: #222 !important;
        color: #eee !important;

        .iconclose{
          color: #fff;
        }
      }
    }

    .modal-risk-tip-sp{
      ::-webkit-scrollbar{
        width: 10px;
        &-thumb{
          color: #333;
        }
      }
      .shell{
        max-width: 350px;
        background-color: #222 !important;
        color: #eee !important;

        .iconclose{
          color: #fff;
        }
      }
    }

    input.sp-transparent{
      appearance: none;
      border: none;
      background-color: transparent;
      text-align: right;
      font-size: 26px;
      color: #fff;
      padding-right: 10px;
    }
  }
</style>